import { createApp } from 'vue'
import router from '../v2/tools/routes'
import TailwindToolsApp from "../v2/tools/TailwindToolsApp.vue";
import AppUtil from "../app/utils/AppUtil";
import UIUtil from "../app/utils/UIUtil";
import ColorUtil from "../app/utils/ColorUtil";
import ThemeUtil from "../app/utils/ThemeUtil";
import FontUtil from "../app/utils/FontUtil";
import Rails from "@rails/ujs";
window.Rails = Rails
import webase from "../v2/tools/model"
window.webase = webase
import styleMap from "../assets/category-map.json"
window.webaseStyleMap = styleMap

webase.utils.app = new AppUtil()
console.log('WeBase style guide app')
console.log(webase.utils.app)
webase.utils.ui = new UIUtil()
webase.utils.color = new ColorUtil()
webase.utils.theme = new ThemeUtil()
webase.utils.font = new FontUtil()

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(TailwindToolsApp)
    app.use(router)
    app.mount('#app')
})
